<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'


export default {

    page: {
        title: 'Словари',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    props: {
        is_popup: { type: Boolean, value: false },
    },

    components: { Layout, PageHeader },

    data() {
        return {
            tableData: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: null,
            sortBy: 'id',
            sortDesc: false,
            fields: [
                { key: 'id', label: 'ID', sortable: true },
                { key: 'name', label: 'Имя', sortable: true },
                { key: 'user_data', label: 'Пользователь', sortable: false },
                { key: 'dev_data', label: 'Разработчик', sortable: true },
                { key: 'updated_at', label: 'Обновлен', sortable: true },
                { key: 'action', label: ''}
            ],
            tableLoading: true,
            watch: false,
        }
    },

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },
    computed: {
        total_rows() {
            return this.$store.getters['dictionaries/GET_DICTIONARIES_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['dictionaries/GET_DICTIONARIES_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }

    },

    async mounted() {
        if(this.session_user_item && this.session_user_item.role === 'administrator'){
            this.fields = [
                { key: 'id', label: 'ID', sortable: true },
                { key: 'name', label: 'Имя', sortable: true },
                { key: 'user_data', label: 'Пользователь', sortable: false },
                { key: 'dev_data', label: 'Разработчик', sortable: true },
                { key: 'updated_at', label: 'Обновлен', sortable: true },
                { key: 'action', label: ''}
            ]
        }
        await this.getData();
    },

    methods: {
        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){
            this.tableLoading = true;
            let data_send = {
                'limit'    : this.perPage,
                'page'     : this.currentPage,
                'sortBy'   : this.sortBy,
                'sortDesc' : this.sortDesc === false ? 'ASC' : 'DESC',
                'filter'   : this.filter,
                'filterOn' : JSON.stringify(this.filterOn)
            }
            await this.$store.dispatch('dictionaries/FETCH_DICTIONARIES_LIST', data_send);
            this.watch = true;
        },
        async delItem(uuid){
            await this.$store.dispatch('dictionaries/FETCH_DICTIONARIES_DELETE', {uuid: uuid});
            await this.getData();
            return false;
        },
        async selectItem(uuid){
            this.$parent.$parent.$parent.loadDictionary(uuid);
            return false;
        }
    },
}
</script>

<template>
    <div>
        <p class="text-muted font-13 mb-4"></p>
        <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        Показывать&nbsp;
                        <b-form-select
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                        ></b-form-select
                        >&nbsp;записей
                    </label>
                </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-right"
                >
                    <label class="d-inline-flex align-items-center">
                        Поиск:
                        <b-form-input
                            v-model="filter"
                            type="search"
                            @change="onFiltered()"
                            placeholder="Введите текст..."
                            class="form-control form-control-sm ml-2"
                        ></b-form-input>
                    </label>
                </div>
            </div>
        </div>
        <!-- Table -->
        <div class="table-responsive mb-0">
            <b-table
                :items="table_data"
                :fields="fields"
                responsive="sm"
                current-page="1"
                :class = "tableLoading ? 'loading' : ''"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :no-local-sorting="true"
            >
                <template #cell(action)="row">
                    <div style="text-align: right;">
                        <a v-if="is_popup" href="javascript:void(0)" @click="selectItem(row.item.uuid)" :id="row.item.id+'_select'" class="btn btn-light btn-sm">
                            <b-tooltip :target="row.item.id+'_select'" placement="top">Выбрать</b-tooltip>
                            <i class="uil uil-check"></i>
                        </a>
                        <router-link v-if="!is_popup" :to="{ name: 'Dictionaries.edit', params: { dictionary_uuid: row.item.uuid, copy: true }}" :id="row.item.id+'_edit'" class="btn btn-light btn-sm">
                            <b-tooltip :target="row.item.id+'_edit'" placement="top">Редактировать</b-tooltip>
                            <i class="uil uil-pen mr-1"></i>
                        </router-link>
                        <router-link v-if="!is_popup" to="#" @click.native="delItem(row.item.uuid)" :id="row.item.id+'_del'" class="btn btn-light btn-sm">
                            <b-tooltip :target="row.item.id+'_del'" placement="top">Удалить</b-tooltip>
                            <i class="uil uil-trash-alt"></i>
                        </router-link>
                    </div>
                </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-left"
                >
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="total_rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.table-responsive-sm{
    transition: all .5s;
}
.table-responsive-sm.loading{
    opacity: 0.3;
}
</style>